<template>
    <v-container class="container">
        <div class="text-center align-md-content-center">
            <v-progress-circular
                :size="70"
                :width="7"
                color="primary"
                indeterminate
            ></v-progress-circular>
        </div>
    </v-container>
</template>

<script>
export default {
    name: 'Logout',
    created() {
        this.$store.dispatch('destroyToken').then(response => {
            console.log(response);
            this.$router.push({ name: 'Login' });
        });
    }
};
</script>
